import {headers} from "./index";

export const getAuditStorayList = ( account, params,callback ) => fetch("/cm-sites-activiti/activiti/getNeedListByTaskIds", {
    method: "post",
    cache: 'no-cache',
    headers: {
        ...headers,
        'Content-Type': 'application/json'
    },
    body: params,
    credentials: 'include'//浏览器发送cookie,解决的问题就是登录之后被踢了
})
.then(response => response.json())
.then(data => {
    callback(data);
});